import { Observable } from 'rxjs';
import { PaginatedData } from '@base/wrappers/paginated-data';
import {
  UserModel,
  UserPlansSummaryFilters,
  UserPlansSummaryModel,
} from '@domain/models/user.model';
import { UpdateUserBatchModel, UpdateUserBatchResult } from '@domain/models/update-user-batch.model';
import { GetUsersPlanSummaryData } from '@domain/usecases/user/get-users-plans-summary.usecase';

export abstract class UserRepository {
  abstract getUsersPlansSummary(params: GetUsersPlanSummaryData): Observable<PaginatedData<UserPlansSummaryModel>>;
  abstract getUser(idUser: string): Observable<UserModel>;
  abstract postChangePassword(idUser:string,currentPassword:string,newPassword:string): Observable<boolean>;
  abstract updateUserBatch(updateBatchData: UpdateUserBatchModel[]): Observable<UpdateUserBatchResult[]>;
  abstract getUserExcelReport(filters: UserPlansSummaryFilters): Observable<File>;
  abstract deleteUserBatch(ids: string[]): Observable<void>;
}
